import React from 'react';

const DownloadButton = ({ text }) => {
  const handleDownload = () => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'transcript.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleDownload}
      className="btn btn-outline-primary btn-sm"
      style={{ borderRadius: '1.5rem', fontWeight: 'bold', minWidth: 90 }}
      aria-label="Download transcript"
    >
      <span role="img" aria-label="download">⬇️</span> Download
    </button>
  );
};

export default DownloadButton;